import * as React from 'react';
var ListContext = /*#__PURE__*/React.createContext({
  listStore: {
    data: [],
    draggable: false,
    currentDraggingIndex: null,
    currentDraggingItem: null,
    listItemRefList: [],
    isOnKeyboardDragging: false,
    keydownHandler: null
  },
  listDispatch: function listDispatch() {}
});
export default ListContext;